import { styled } from '@clickcease/cc-client-components-lib'

export const GoogleParamsTabStyled = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  width: '648px',
  height: '455px',
  overflowY: 'auto',
})

export const GoogleParamsDescription = styled('div', {
  fontWeight: '$l',
  fontSize: '$md',
  marginTop: '$8',
  lineHeight: '22px',
})

export const GoogleParamsTitle = styled('div', {
  marginTop: '20px',
})
export const GoogleParamsYouHaveUtm = styled('div', {
  margin: '20px 0px 8px 0px',
  display: 'flex',
})

export const AppendTheBelow = styled('div', {
  fontWeight: '$rb',
  fontSize: '$md',
  color: '$mainTextColor',
  margin: '$8 0px $4',
})

export const CheckboxSection = styled('div', {
  display: 'flex',
  gap: '$6',
  flexWrap: 'wrap',
})

export const CheckboxContainer = styled('div', {
  display: 'flex',
  alignItems: 'center',
  width: '150px',
})

export const Link = styled('a', {
  all: 'unset',
  cursor: 'pointer',
  color: '$primaryColor',
  textDecoration: 'underline',
  fontSize: '$md',
  fontWeight: '$r',
  '&:hover': {
    color: '$buttonHovered',
  },
})
